<template>
  <LegalDocPage :template="cguTemplate" document="cgu" />
</template>

<script setup lang="ts">
import LegalDocPage from '@/features/legal/components/legal-doc-page/legal-doc-page.vue'
import cguTemplate from '@/features/legal/templates/cgu.md?raw'
</script>
